import axios, { AxiosError, AxiosRequestConfig } from 'axios';

import config from '../../config';

const API_HOST_URL = config.API_HOST_URL + '/api/v1/';
axios.defaults.baseURL = API_HOST_URL;
axios.defaults.withCredentials = false;

// axios 1.x以降でTypeSafeなカスタムRequestConfig機能が追加される予定
// https://github.com/axios/axios/pull/1964
declare module 'axios' {
  export interface AxiosRequestConfig {
    hasCustomActionOnNotFound?: boolean;
    hasCustomActionOnNotAuthorized?: boolean;
  }
}

export const multiPartFormHeaderConfig: AxiosRequestConfig = {
  headers: { 'content-type': 'multipart/form-data' },
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export async function get<T = any>(path: string, config?: AxiosRequestConfig) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('QHC_LOGIN_TOKEN') || 'GUEST';
  const response = await axios.get<T>(path, config);
  return response.data;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export async function post<T = any>(path: string, data?: any, config?: AxiosRequestConfig) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('QHC_LOGIN_TOKEN') || 'GUEST';
  const response = await axios.post<T>(path, data, config);
  return response.data;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-explicit-any */
export async function put<T = any>(path: string, data?: any, config?: AxiosRequestConfig) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('QHC_LOGIN_TOKEN') || 'GUEST';
  const response = await axios.put<T>(path, data, config);
  return response.data;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export async function del<T = any>(path: string, config?: AxiosRequestConfig) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('QHC_LOGIN_TOKEN') || 'GUEST';
  const response = await axios.delete<T>(path, config);
  return response.data;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export async function patch<T = any>(path: string, data?: any, config?: AxiosRequestConfig) {
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('QHC_LOGIN_TOKEN') || 'GUEST';
  const response = await axios.patch<T>(path, data, config);
  return response.data;
}

axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error: AxiosError) {
    return Promise.reject(error);
  },
);
